import { Component } from '@theme/component';

/**
 * „Alte nuanțe” pe două rânduri (blocul `perdele-produs-alte-nuante`). Pliul e în CSS, de la prima pictare; aici:
 * butonul „Vezi toate / Arată mai puține” (`aria-expanded`), ascunderea butonului când totul încape în două rânduri
 * și scoaterea din ordinea de tab (`inert`) a bulinelor rămase sub pliu. Se recalculează la redimensionare.
 *
 * @typedef {object} Refs
 * @property {HTMLUListElement} lista
 * @property {HTMLButtonElement} [buton]
 *
 * @extends {Component<Refs>}
 */
class PerdeleNuanteComponent extends Component {
  requiredRefs = ['lista'];

  /** @type {ResizeObserver | undefined} */
  #observator;

  connectedCallback() {
    super.connectedCallback();
    this.#observator = new ResizeObserver(() => this.#actualizeaza());
    this.#observator.observe(this.refs.lista);
    this.#actualizeaza();
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    this.#observator?.disconnect();
  }

  get #deschis() {
    return this.refs.buton?.getAttribute('aria-expanded') === 'true';
  }

  comuta() {
    const { buton } = this.refs;
    if (!buton) return;
    const deschis = !this.#deschis;
    buton.setAttribute('aria-expanded', String(deschis));
    this.classList.toggle('perdele-nuante--deschis', deschis);
    this.#actualizeaza();
  }

  #actualizeaza() {
    const { lista, buton } = this.refs;
    const elemente = /** @type {HTMLElement[]} */ ([...lista.children]);
    if (!buton || !elemente.length) return;

    // rândurile, după poziția verticală (ordinea vizuală: bulina curentă poate fi mutată prima cu `order`)
    const randuri = [...new Set(elemente.map((li) => li.offsetTop))].sort((a, b) => a - b);
    const incape = randuri.length <= 2;
    buton.hidden = incape;
    this.classList.toggle('perdele-nuante--incape', incape);

    const prag = randuri[2] ?? Infinity;
    const ascunde = !incape && !this.#deschis;
    for (const li of elemente) {
      li.inert = ascunde && li.offsetTop >= prag;
    }
  }
}

if (!customElements.get('perdele-nuante-component')) {
  customElements.define('perdele-nuante-component', PerdeleNuanteComponent);
}
